import {Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ObjektDataService} from '../services/objekt-data.service';
import {MainDataModels} from '../models/maindata-models';
import {v4 as uuidv4} from 'uuid';
import {MainDataService} from '../services/main-data.service';
import {MatDialog} from '@angular/material/dialog';
import {TerminEintragComponent} from './pendenzen/termin-eintrag/termin-eintrag.component';
import {AufgabeEintragComponent} from './pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';
import {NotizEintragComponent} from './pendenzen/notiz-eintrag/notiz-eintrag.component';
import {DashboardService} from '../services/dashboard.service';
import {MessageBoxService} from '../services/message-box.service';
import {SwissSettingsService} from '../services/swiss-settings.service';
import {VinavonUpdateService} from '../services/vinavon-update.service';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {HelperService} from '../services/helper.service';
import {BenutzerModels} from '../models/benutzer-models';
import {DeviceDetectionService} from '../services/device-detection-service';
import {TreeviewService} from '../services/treeview.service';
import {BehaviorSubject, interval, Subscription} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {environment} from 'src/environments/environment';
import {SwissFieldBase} from '../swiss-forms/fields/swiss-field-base';

@Component({
    selector: 'app-home-layout', templateUrl: './home-layout.component.html', styleUrls: ['./home-layout.component.scss'],
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
    events: string[] = [];
    currentUser = '';
    currentMandant = '';
    sideMenuOpened_Backup = true;
    showServiceApp = false;
    showVinavon = false;
    showTimeApp = false;
    showWareneingang = false;
    showPDFViewer = true;
    @ViewChild('sidenav') sideNavigation?: any;

    isExpanded = false;

    public vinavonVersion: string = environment.version;
    /* ENDE Neue Aufgabe erstellen */
    /* Badge-Icons: Anzahl Heutige Termine / Heutige Aufgaben / Heutige Notizen  */
    public cntAppointmentsToday?: number = undefined;
    public cntTasks?: number = undefined;
    /* ENDE Neue Notiz erstellen */
    public cntNotes?: number = undefined;
    public currentRoute$ = new BehaviorSubject('dashboard');
    /* ENDE Neuer Termin */
    imgSource = './assets/images/user.png';
    /* Neue Neue Aufgabe erstellen */
    private dataForCalendarTask?: MainDataModels.AufgabeMitBenutzer;
    private currAufgabeMitBenutzern?: MainDataModels.AufgabeMitBenutzer;
    /* Neue Notiz erstellen */
    private dataForCalendarNote?: MainDataModels.NotizMitBenutzer;
    private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;
    /* Neuer Termin erstellen */
    private dataForCalendar?: MainDataModels.TerminMitBenutzer;
    private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;
    private destroyRef = inject(DestroyRef);

    constructor(
        private treeViewCache: TreeviewService,
        private deviceDetectionService: DeviceDetectionService,
        public router: Router,
        private svcMainData: MainDataService,
        private svcDashboard: DashboardService,
        private svcMessageBox: MessageBoxService,
        private svcSwissSettingsService: SwissSettingsService,
        public dialog: MatDialog,
        private userAuthService: UserAuthenticationService,
        private helperService: HelperService,
        private svcObjektData: ObjektDataService,
        protected svcVinavonUpdate: VinavonUpdateService) {
    }

    ngOnInit(): void {
        if (this.deviceDetectionService.getDevice().device.type === 'mobile') {
            this.showServiceApp = true;
        }

        this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.currentRoute$.next(val.url.split('/')[1]);
            }
        });
        this.currentRoute$.next(this.router.url.split('/')[1]);

        this.userAuthService.checkAuthenticated().then(async (res) => {
            if (res) {
                this.treeViewCache.startTreeViewCache();
                this.showVinavon = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CNavigatorMobile);
                this.showServiceApp = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CServiceApp);
                this.showTimeApp = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CMobileTime);
                this.showWareneingang = false;
                this.showPDFViewer = true;

                // Wenn keine Lizenz für den Benutzer vorhanden sind, Login-Schirm öffnen
                if (!this.showVinavon && !this.showServiceApp && !this.showTimeApp) {
                    if (this.userAuthService.currentUserInfo.clearName !== 'demo') {
                        await this.userAuthService.logoutUser('/login');
                    } else {
                        this.showTimeApp = true;
                        this.routePage();
                    }
                }

                this.svcSwissSettingsService.waitForSwissAppConfigs().then(() => {
                    const user = this.userAuthService.getCurrentAuthenticatedUser();
                    if (!user) {
                        this.svcMessageBox.showError('MAIN_APP_DIALOG.ERROR_DIALOG.ERROR_USER_NOT_AUTHENTICATED.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ERROR_USER_NOT_AUTHENTICATED.title');
                        throw Error('Couldn\'t load user');
                    }
                    this.currentUser = user.loginname;
                    this.currentMandant = user.mandator;

                    if (this.showVinavon) {
                        this.refreshObjectFields();
                    }

                    this.helperService.getPageRefreshURL().then((url: any) => {
                        if (url === 'internalRouting') {
                            this.helperService.delPageRefreshURL();
                        } else if ((typeof url === 'string') && url !== '') {
                            this.helperService.delPageRefreshURL();
                            this.router.navigate([url]);
                        } else {
                            this.routePage();
                        }
                    });
                });
            } else {
                await this.router.navigate(['/login/401']);
            }
        });

        this.helperService.addPeriodicalCheck(this.countCntNotes.bind(this));
        this.svcMainData.getNoteCount().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (count) => {
                this.cntNotes = count.unreadNotes;
            }, error: () => {
                this.cntNotes = 0;
            }
        });
        this.svcMainData.getUserNotes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.svcMainData.setNoteCount(res);
            }, error: () => {
            }
        });
    }

    ngOnDestroy(): void {

    }

    InitNeueNotiz(): void {
        const user = this.userAuthService.getCurrentAuthenticatedUser();
        if (!user) {
            return;
        }
        this.dataForCalendarNote = {
            notiz: {
                noteID: uuidv4(),
                objectID: '',
                objDesc: '',
                adressID: undefined,
                contactID: undefined,
                responsible: user.loginname,
                created: new Date(),
                createdBy: user.loginname,
                modified: new Date(),
                modifiedBy: user.loginname,
                notes: '',
                description: '',
                done: 0,
                private: false,
                wasRead: 0,
            }, mitarbeiter: [], notizKategorien: [], istNeueNotiz: true,
        };
    }

    neueNotiz(): void {
        this.InitNeueNotiz();
        const objectID = this.svcObjektData.getCurrentObjectID();

        if (objectID && this.dataForCalendarNote) {
            this.dataForCalendarNote.notiz.objectID = objectID;
        }

        const dialogRef = this.dialog.open(NotizEintragComponent, {
            disableClose: true, width: '800px', data: this.dataForCalendarNote,
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currNotizMitBenutzern = result;
                    if (this.currNotizMitBenutzern) {
                        this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                            next: () => {
                                this.svcMessageBox.showSuccess('Die Notiz wurde erfolgreich gespeichert.', 'Erfolgreich');
                                this.svcObjektData.reloadObjActivities();
                                this.svcDashboard.reloadDashboardBadgeIcons();
                                this.svcMainData.refreshNoteCount();
                            }, error: (error) => {
                                console.log(error);
                                this.svcMessageBox.showError('Die Notiz konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            },
                        });
                    }
                }
            },
        });
    }

    public closeMenu(): void {
        this.sideMenuOpened_Backup = this.sideNavigation._opened;
        if (this.sideMenuOpened_Backup) {
            this.sideNavigation.close();
        }
    }

    public openMenu(): void {
        // öffnet es nur, wenn es zuvor schon offen war
        if (this.sideMenuOpened_Backup) {
            this.sideNavigation.open();
        }
    }

    protected countCntNotes(): Subscription {
        return interval(60000).subscribe(() => {
            this.svcMainData.getUserNotes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                next: (res) => {
                    this.svcMainData.setNoteCount(res);
                }, error: () => {
                }
            });
        });
    }

    protected async logout(): Promise<void> {
        await this.userAuthService.logoutUser('/login');
    }

    protected neueAufgabe(): void {
        this.InitNeueAufgabe();
        const objectID = this.svcObjektData.getCurrentObjectID();

        if (objectID && this.dataForCalendarTask) {
            this.dataForCalendarTask.aufgabe.objectID = objectID;
        }

        const dialogRef = this.dialog.open(AufgabeEintragComponent, {
            disableClose: true, width: '800px', data: this.dataForCalendarTask,
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currAufgabeMitBenutzern = result;
                    if (this.currAufgabeMitBenutzern) {
                        this.svcMainData.saveAufgabe(this.currAufgabeMitBenutzern).subscribe({
                            next: () => {
                                this.svcMessageBox.showSuccess('Die Aufgabe wurde erfolgreich gespeichert.', 'Erfolgreich');
                                this.svcObjektData.reloadObjActivities();
                                this.svcDashboard.reloadDashboardBadgeIcons();
                            }, error: (error) => {
                                console.log(error);
                                this.svcMessageBox.showError('Die Aufgabe konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            },
                        });
                    }
                }
            },
        });
    }

    protected openNotes(): void {
        this.router.navigateByUrl('/meinenotizen');
    }

    protected openTasks(): void {
        this.router.navigateByUrl('/meineaufgaben');
    }

    protected openAppointments(): void {
        this.router.navigateByUrl('/meinetermine');
    }

    protected neuerTermin(): void {
        this.InitNeuerTermin();
        const objectID = this.svcObjektData.getCurrentObjectID();

        if (objectID && this.dataForCalendar) {
            this.dataForCalendar.termin.objectID = objectID;
        }

        const dialogRef = this.dialog.open(TerminEintragComponent, {
            disableClose: true, width: '800px', data: this.dataForCalendar,
        });

        this.svcMainData.reloadCalendarData();

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currTerminMitBenutzern = result;
                    if (this.currTerminMitBenutzern) {
                        if (this.currTerminMitBenutzern.mitarbeiter.length > 1) {
                            this.currTerminMitBenutzern.termin.groupID = uuidv4();
                        }
                        this.svcMainData.saveTermin(this.currTerminMitBenutzern).subscribe({
                            next: () => {
                                this.svcMessageBox.showSuccess('Der Termin wurde erfolgreich gespeichert.', 'Erfolgreich');
                                this.svcMainData.reloadCalendarData();
                                this.svcObjektData.reloadObjActivities();
                                this.svcDashboard.reloadDashboardBadgeIcons();
                            }, error: (error) => {
                                console.log(error);
                                this.svcMessageBox.showError('Der Termin konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            },
                        });
                    }
                }
            },
        });
    }

    private routePage(): void {
        if (this.router.url.includes('pdfviewer')) {
            this.closeMenu();
        }
    }

    private InitNeueAufgabe(): void {
        const heute = new Date();
        heute.setHours(0, 0, 0, 0);
        this.dataForCalendarTask = {
            aufgabe: {
                taskUID: uuidv4(),
                objectID: '',
                adressID: undefined,
                responsible: this.userAuthService.getCurrentAuthenticatedUser()!.loginname,
                description: '',
                dueDate: heute,
                importance: 1,
                done: false,
                percentDone: 0,
                status: 0,
                private: 0,
                accepted: 1,
                wasRead: 1,
                reminder: 0,
                notes: '',
                startdate: heute,
            }, mitarbeiter: [], aufgabeKategorien: [], istNeueAufgabe: true,
        };
    }

    private InitNeuerTermin(): void {
        this.dataForCalendar = {
            termin: {
                id: uuidv4(),
                objectID: this.svcObjektData.getCurrentObjectID(),
                adressID: undefined,
                description: '',
                username: this.userAuthService.getCurrentAuthenticatedUser()!.loginname,
                location: '',
                private: 0,
                reminder: 1,
                reminderNumber: 15,
                notes: '',
                busyStatus: 2,
            }, mitarbeiter: [], terminKategorien: [], istNeuerTermin: true, nurDiesenTerminBearbeiten: false,
        };
    }

    private async refreshObjectFields(): Promise<boolean> {
        return new Promise(resolve => {
            this.svcObjektData.getAllFormFields().subscribe({
                next: async (fields: SwissFieldBase<any>[]) => {
                    const typeCodes: number[] = [];
                    const groupCodeNumber: number[] = [];
                    fields.forEach(element => {
                        if (element.iD_ObjectType && typeCodes.indexOf(element.iD_ObjectType) === -1) {
                            typeCodes.push(element.iD_ObjectType);
                        }
                        if (element.iD_SwissAppGroup && groupCodeNumber.indexOf(element.iD_SwissAppGroup) === -1) {
                            groupCodeNumber.push(element.iD_SwissAppGroup);
                        }
                    });
                    for (const typeCode of typeCodes) {
                        for (const groupCode of groupCodeNumber) {
                            const arr = fields.filter(field => field.iD_ObjectType === typeCode && field.iD_SwissAppGroup === groupCode);
                            if (arr.length > 0) {
                                await this.svcObjektData.setOfflineFormFields(groupCode, typeCode, arr);
                            }
                        }
                    }
                    resolve(true);
                },
                error: (err) => {
                    console.error(err);
                    resolve(false);
                }
            });
        });
    }
}
